import { CONFIG } from 'src/global-config';
import { MainLayout } from 'src/layouts/main';
import { DashboardLayout } from 'src/layouts/dashboard';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function Layout({ children }: Props) {
  // If home should show dashboard, use dashboard layout
  if (CONFIG.homeRedirectToDashboard) {
    if (CONFIG.auth.skip) {
      return <DashboardLayout>{children}</DashboardLayout>;
    }

    return (
      <AuthGuard>
        <DashboardLayout>{children}</DashboardLayout>
      </AuthGuard>
    );
  }

  // Otherwise use main layout
  return <MainLayout>{children}</MainLayout>;
}
